import { useEffect } from "react";

import "./HubspotChatVisibilityManager.scss";

export default function HubspotChatVisibilityManager() {
  useEffect(() => {
    document
      .getElementById("hubspot-messages-iframe-container")
      ?.classList.add("backpack-hidden");
    return () => {
      document
        .getElementById("hubspot-messages-iframe-container")
        ?.classList.remove("backpack-hidden");
    };
  }, []);

  return null;
}
